import { useMemo } from "react";

export const useEcommerceLogic = () => {

    const logic = useMemo(() => {

        const defaultLogic = {
            showHomeCategories: true,
        };

        let showHomeCategories = defaultLogic.showHomeCategories;

        if (window.location.pathname === "/ecomm" || window.location.pathname === "/ecomm/") {
            showHomeCategories = true;
        } else {
            showHomeCategories = false;
        }

        // if there are any search params then don't show the home categories
        if (window.location.search.length > 0) {
            showHomeCategories = false;
        }

        return {
            showHomeCategories
        };
    }, [window.location.pathname, window.location.search]);

    return logic;
};
